export default "__VITE_ASSET__i9pvrP1J__"